// extracted by mini-css-extract-plugin
export default {"RefSelectorTabs":"RefSelector-module__RefSelectorTabs--YbwCq","RefSelectorTabLink":"RefSelector-module__RefSelectorTabLink--C9Lub"};